import { createFileRoute } from "@tanstack/react-router";

import { findAreaBySlug } from "@/data/local-areas";
import { routeHead } from "@/lib/seo-head";
import LocalAreaPage from "@/pages/LocalAreaPage";

export const Route = createFileRoute("/architecte-interieur-charbonnieres-les-bains")({
  head: () => {
    const area = findAreaBySlug("architecte-interieur-charbonnieres-les-bains");
    return routeHead({
      path: "/architecte-interieur-charbonnieres-les-bains",
      title: `Architecte d'intérieur ${area?.city ?? "Lyon"} | JIIA Studio`,
      description: area?.intro ?? "",
    });
  },
  component: LocalAreaPage,
});
